module.exports = __webpack_public_path__ + "img/hint.ffc6d1f5.svg";